import { render } from "./loader.vue?vue&type=template&id=93ff64d6"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\SpliytGit\\SpliytAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__